import { render } from "./TerritoryPicker.vue?vue&type=template&id=2d3b5a82&scoped=true"
import script from "./TerritoryPicker.vue?vue&type=script&lang=ts"
export * from "./TerritoryPicker.vue?vue&type=script&lang=ts"

import "./TerritoryPicker.vue?vue&type=style&index=0&id=2d3b5a82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d3b5a82"

export default script